import AccountContext from 'context/AccountContext';
import groupBy from 'lodash/groupBy';
import { useContext } from 'react';
import { UnifiedPermitType } from 'types/generatedSchemaTypes';
import { isPermitForParkingZone } from 'utils/permitUtils';

const matchablePermitTypes: UnifiedPermitType[] = ['ACCESS', 'LOYALTY'];
type MatchablePermitType = (typeof matchablePermitTypes)[number];

const useGetMatchingPermitsForParkingZone = (
  parkZoneUid: string | undefined,
  matchingPermitTypesFilter: MatchablePermitType[] = [] // If no permit types are provided, all permit types are considered
) => {
  const {
    loading,
    customer: { permits },
  } = useContext(AccountContext);

  const matchingPermits = !parkZoneUid
    ? []
    : permits?.filter((permit) => {
        const isParkingZoneMatching = isPermitForParkingZone(
          parkZoneUid,
          permit
        );

        const permitTypeMatches = matchingPermitTypesFilter?.length
          ? matchingPermitTypesFilter?.includes(
              permit?.permitType as MatchablePermitType
            )
          : true;
        return isParkingZoneMatching && permitTypeMatches;
      });

  return {
    loading: loading,
    matchingPermits: matchingPermits,
    groupedMatchingPermits: groupBy(matchingPermits, 'permitType'),
  };
};

export default useGetMatchingPermitsForParkingZone;
